import { Modal } from 'antd'

import Styles from './RemoveGuestModal.module.scss'
import { ReactComponent as CloseIcon } from 'assets/icons/close24.svg'
import { FetchStatus, RemoveGuestModalProps } from './Types'
import { RemoveGuestWithoutBranches } from './RemoveGuestWithoutBranches'
import { RemoveGuestWithBranches } from './RemoveGuestWithBranches'
import { Spinner } from 'common/Spinner/Spinner'

const RemoveGuestModal = ({
  visible,
  setVisible,
  onClose,
  onRemove,
  onRemoveAndDelete,
  onRemoveAndTransferOwnership,
  guestName,
  status,
  branches,
}: RemoveGuestModalProps) => {
  const handleClose = () => {
    onClose?.()
    setVisible(false)
  }

  const renderContent = () => {
    switch (status) {
      case FetchStatus.success:
        return branches && branches.length > 0 ? (
          <RemoveGuestWithBranches
            guestName={guestName}
            branches={branches}
            onRemoveAndTransferOwnership={onRemoveAndTransferOwnership}
            onRemoveAndDelete={onRemoveAndDelete}
          />
        ) : (
          <RemoveGuestWithoutBranches guestName={guestName} onRemove={onRemove} />
        )

      case FetchStatus.rejected:
        return (
          <div className={Styles.body}>
            Oops! There was an error checking for unmerged linked copies for this guest. Please try again later.
          </div>
        )

      case FetchStatus.loading:
        return (
          <div className={Styles.body} data-testid="loading">
            <Spinner />
          </div>
        )
    }
  }

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      wrapClassName={Styles.container}
      footer={null}
      closable={false}
      width={560}
    >
      <div className={Styles.header}>
        <h1 className={Styles.headerText}>
          {status === FetchStatus.rejected ? 'Something went wrong' : 'Remove from Workspace?'}
        </h1>
        <button className={Styles.closeButton} onClick={() => setVisible(false)} aria-label="Close modal">
          <CloseIcon />
        </button>
      </div>
      {renderContent()}
    </Modal>
  )
}

export { RemoveGuestModal }
